import { CartAddEvent } from '@theme/events';

/**
 * Add-on product in the cart drawer. Adds the chosen quantity, then fires the theme's
 * cart event so the drawer and cart bubble re-render with the new line.
 */
class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.cart-upsell__add');
    this.button?.addEventListener('click', this.#add);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#add);
  }

  #add = async () => {
    const select = /** @type {HTMLSelectElement | null} */ (this.querySelector('.cart-upsell__quantity'));
    const errorEl = this.querySelector('.cart-upsell__error');
    const quantity = Number(select?.value || 1);
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
      .filter(Boolean);

    this.button?.setAttribute('aria-busy', 'true');
    errorEl?.classList.add('hidden');

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(this.dataset.variantId), quantity }],
          sections: sectionIds.join(','),
        }),
      });
      const data = await response.json();

      if (data.status) {
        if (errorEl) {
          errorEl.textContent = data.description || data.message;
          errorEl.classList.remove('hidden');
        }
        return;
      }

      const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());

      this.dispatchEvent(
        new CartAddEvent({}, 'cart-upsell', {
          source: 'cart-upsell',
          itemCount: cart.item_count,
          variantId: this.dataset.variantId,
          sections: data.sections,
        })
      );
    } catch (error) {
      console.error(error);
    } finally {
      this.button?.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('cart-upsell')) customElements.define('cart-upsell', CartUpsell);
